{
  "internalPortal": {
    "components": {
      "tabs": {
        "reports": "Reports"
      },
      "reports": {
        "title": "Reports",
        "empty": {
          "title": "No reports for this organization",
          "description": "Power BI reports appear here when they are assigned to the organization."
        },
        "error": {
          "title": "Failed to load report",
          "message": "Something went wrong while loading the report. Please try again later or contact support if the issue persists"
        }
      }
    }
  }
}
